<template>
    <div class="flex flex-col gap-4">
        <h2>
            Input
        </h2>

        <hts-form-input
            v-model="value"
            placeholder="disabled" />

        <hts-form-input
            v-model="value"
            disabled
            placeholder="disabled" />

        <hts-form-input
            v-model="value"
            readonly
            placeholder="readonly" />

        <!-- //////////////////////////////////// -->
        <h2>
            Select options
        </h2>
        <hts-select-node
            v-model="value"
            v-model:name="valueText" />

        <hts-select-node
            v-model="value"
            v-model:name="valueText"
            disabled />

        <hts-select-node
            v-model="value"
            v-model:name="valueText"
            readonly />

        <!-- //////////////////////////////////// -->
        <h2>
            Select multiple options
        </h2>

        <hts-select-node
            v-model="valueArr"
            multiple />

        <hts-select-node
            v-model="valueArr"
            disabled
            multiple />

        <hts-select-node
            v-model="valueArr"
            readonly
            multiple />

        <!-- Date -->
        <h2>
            Date
        </h2>

        <hts-form-date
            v-model="value"
            type="datetime" />

        <hts-form-date
            v-model="value"
            type="datetime"
            disabled />

        <hts-form-date
            v-model="value"
            type="datetime"
            readonly />

        <h2>
            Phone
        </h2>

        <hts-form-phone v-model="phone" />

        <hts-form-phone
            v-model="phone"
            disabled />

        <hts-form-phone
            v-model="phone"
            readonly />

        <h2>
            radio
        </h2>

        <hts-form-radio
            v-model="reason"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            value-key="key"
            label-key="label" />

        <hts-form-radio
            v-model="reason"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            value-key="key"
            label-key="label"
            disabled />

        <hts-form-radio
            v-model="reason"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            value-key="key"
            label-key="label"
            readonly />

        <h2>
            Checkbox
        </h2>

        <hts-form-checkbox
            v-model="reasons"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            check-key="key"
            check-label="label" />

        <hts-form-checkbox
            v-model="reasons"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            check-key="key"
            check-label="label"
            disabled />

        <hts-form-checkbox
            v-model="reasons"
            label="Lý do thay đổi đội xe"
            :items="reasonOptions"
            check-key="key"
            check-label="label"
            readonly />

        <h2>
            Textarea
        </h2>

        <hts-form-textarea
            v-model="value"
            placeholder="disabled" />

        <hts-form-textarea
            v-model="value"
            disabled
            placeholder="disabled" />

        <hts-form-textarea
            v-model="value"
            readonly
            placeholder="readonly" />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const phone = ref({
  countryCode: '',
  phone: '',
  code: ''
})
const reason = ref('')
const reasons = ref([])
const value = ref('text nè')
const valueText = ref('text nè')
const valueArr = ref([])
const valueArrText = ref([])
const reasonOptions = [
  {
    key: 'requiredPartner',
    label: 'Đội xe yêu cầu'
  },
  {
    key: 'requiredCustomer',
    label: 'Khách hàng yêu cầu'
  },
  {
    key: 'other',
    label: 'Khác'
  }
]
const fileUpload = ref()
</script>
